import { BrowserRouter as Router, Route } from "react-router-dom";
import React from 'react';
import Firebase from "./components/Firebase";
import Root from './pages/root';
import Privacy from "./pages/privacy/privacy";
import WhoWeAre from "./pages/who_we_are/who_we_are";
import Catalog from "./pages/catalog/catalog";



export default (
    <Router>
        <div>
           {/* <Route exact path={'/admin'}><Catalog className="container" firebase={new Firebase()}/></Route>*/}
            <Route exact path={'/'}><Root className="container" firebase={new Firebase()}/></Route>
            <Route exact path={'/privacy'}><Privacy className="container"/></Route>
            <Route exact path={'/who_we_are'}><WhoWeAre className="container"/></Route>

        </div>
    </Router>
);


//